import { LinkType } from '@easeltv/analytics';
import { MenuLink } from '@easeltv/client-sdk';
import { useDropdown } from '@easeltv/hooks';

import { MenuLinkGroupId } from '../../../hooks/useGetMenu/useGetMenu';
import LinkAtom from '../../Atoms/LinkAtom';
import { getDestination } from '../../Atoms/LinkAtom/LinkAtom.helpers';
import {
    HeaderDropdown,
    HeaderDropdownMenu,
    HeaderIcon,
} from './ContextMenuBlock.styled';

/* ---------------------------------- Types --------------------------------- */

export interface DumbContextMenuBlockProps
    extends ReturnType<typeof useDropdown> {
    /** Whether the current user is logged in */
    isAuthenticated: boolean;

    /** Menu items for logged in users */
    loggedInItems: MenuLink[];

    /** Menu items for logged out users */
    loggedOutItems: MenuLink[];

    /** Flag if registration is enabled */
    registrationEnabled: boolean;

    /** Callback to track menu link clicks */
    trackMenuLinkClicked: (
        menuSource: string,
    ) => (destination: LinkType) => void;
}

/* --------------------------------- Helpers -------------------------------- */

/**
 * getMenuIcon
 *
 * Returns the appropriate icon class based on the registrationEnabled and
 * isAuthenticated flags
 *
 * @param registrationEnabled - Whether registration is enabled
 * @param isAuthenticated - Whether the user is authenticated
 * @returns
 */
const getMenuIcon = (
    registrationEnabled: boolean,
    isAuthenticated: boolean,
) => {
    if (!registrationEnabled) {
        return 'fa-settings';
    }

    if (isAuthenticated) {
        return 'fa-user-logged-in';
    }

    return 'fa-user-logged-out';
};

/* -------------------------------- Component ------------------------------- */

const DumbContextMenuBlock = ({
    containerRef,
    isAuthenticated,
    loggedInItems,
    loggedOutItems,
    registrationEnabled,
    showDropdown,
    toggleDropdown,
    trackMenuLinkClicked,
}: DumbContextMenuBlockProps) => (
    <HeaderDropdown ref={containerRef}>
        <HeaderIcon onClick={toggleDropdown} role="button">
            <i
                className={`fa ${getMenuIcon(
                    registrationEnabled,
                    isAuthenticated,
                )}`}
            />
        </HeaderIcon>
        {showDropdown && (
            <HeaderDropdownMenu>
                {registrationEnabled && isAuthenticated
                    ? loggedInItems.map((item) => (
                          <LinkAtom
                              key={item.id}
                              data={item}
                              section="header"
                              callback={() => {
                                  trackMenuLinkClicked(
                                      MenuLinkGroupId.loggedIn,
                                  )(getDestination(item));
                              }}
                          />
                      ))
                    : loggedOutItems.map((item) => (
                          <LinkAtom
                              key={item.id}
                              data={item}
                              section="header"
                              callback={() => {
                                  trackMenuLinkClicked(
                                      MenuLinkGroupId.loggedOut,
                                  )(getDestination(item));
                              }}
                          />
                      ))}
            </HeaderDropdownMenu>
        )}
    </HeaderDropdown>
);

/* --------------------------------- Export --------------------------------- */

export default DumbContextMenuBlock;
